import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const templateDraftQueries = [
  'waiverTemplates',
  'waiverTemplate',
];

/** Template mutations that change the unpublished-templates dashboard tile. */
const templateDashboardQueries = [
  ...templateDraftQueries,
  'waiverDashboardSummary',
];

/** Queries that change when a template is published, archived, or otherwise status-updated. */
const templatePublishedQueries = [
  ...templateDashboardQueries,
  'waiverPublishedTemplates',
  'waiverForms',
  'waiverForm',
];

const waiverTemplateMutations: UpdatesConfig['Mutation'] = {
  waiverTemplateCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(['waiverTemplates', 'waiverDashboardSummary'], cache);
  },
  waiverTemplateUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(templateDashboardQueries, cache);
  },
  waiverTemplateStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    // Publishing a template syncs draft forms to the new version and updates
    // the published-templates list used by form create.
    invalidateQuery(templatePublishedQueries, cache);
  },
  waiverTemplateDiscard: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(templateDashboardQueries, cache);
  },
};

export default waiverTemplateMutations;
